<p>product-batch-serial-stock works!</p>
